<template>
  <div class="app-version">
    Версия {{ version }}
    <template v-if="buildTime"> &middot; сборка {{ buildTime }}</template>
  </div>
</template>

<script>
/* global __APP_VERSION__, __APP_BUILD_TIME__ */

// Значения подставляет webpack.DefinePlugin на этапе сборки (vue.config.js):
// версия = короткий хеш коммита (вне git — версия из package.json),
// время = момент сборки.
const VERSION = typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "dev";
const BUILD_TIME =
  typeof __APP_BUILD_TIME__ === "string" ? __APP_BUILD_TIME__ : "";

/**
 * Время сборки показываем читаемо и без секунд: по нему сверяют «какой dist
 * выложен», точность до минуты достаточна.
 */
function formatBuildTime(iso) {
  if (!iso) return "";

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  return date.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}

export default {
  name: "CurrentVersion",

  computed: {
    version: () => VERSION,
    buildTime: () => formatBuildTime(BUILD_TIME)
  }
};
</script>

<style scoped>
.app-version {
  @apply text-xs leading-relaxed text-gray-400 font-mono select-all;
}
</style>
